import React, { useState } from 'react'
import { Box, Typography } from '@mui/material'
import ActivityBlockCard from '../components/ActivityBlockCard'
import PeriodNavigator from '../components/PeriodNavigator'
import { todayIso } from '../format'
import { advancedColors } from '../theme'
import { ActivityBlock } from '../activityBlock'
import { usePatientActivity } from '../api/patientActivity'
import { WeekDay, weekDaysFor, weekRangeLabel } from './weekDates'

const DayColumn = ({ day, blocks }: { day: WeekDay; blocks: ActivityBlock[] }) => (
  <Box>
    <Typography variant="overline" sx={{ mb: 1 }}>
      {day.label.toUpperCase()} {day.dayOfMonth}
    </Typography>
    {blocks.length > 0 ? (
      blocks.map((block) => <ActivityBlockCard key={block.id} block={block} />)
    ) : (
      <Typography variant="subtitle2" sx={{ color: advancedColors.inkFaint }}>
        No activity
      </Typography>
    )}
  </Box>
)

const WeeklyActivityBoard = () => {
  const [weekOffset, setWeekOffset] = useState(0)
  const days = weekDaysFor(todayIso(), weekOffset)
  const activity = usePatientActivity()

  return (
    <Box>
      <PeriodNavigator
        label={weekRangeLabel(days)}
        unit="week"
        onStep={(delta) => setWeekOffset((value) => value + delta)}
      />

      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(7, minmax(0, 1fr))', gap: 1.5 }}>
        {days.map((day) => (
          <DayColumn key={day.iso} day={day} blocks={activity.get(day.iso) ?? []} />
        ))}
      </Box>
    </Box>
  )
}

export default WeeklyActivityBoard
